module.exports = __webpack_public_path__ + "47fc1add/img/document.e2130c6b.svg";